import * as Constants from "../constants";

export default function (state = {}, action) {
  switch (action.type) {
  case Constants.EMPLOYEE_JOB_HISTORY_SUCCESS:
    return {
      ...state,
      [action.id]: action.payload
    };
  default:
    return state;
  }
}